import { Typography } from '@scaleaq/scaleui';

import type { ChipsButtonProps } from '@/components/chips/chips.types';
import { StyledButton } from '@/components/chips/chipsButton/chipsButton.style';
import { Loader } from '@/components/Loader.tsx';
import { Icon } from '@/utils';

export const ChipsButton = ({
  label,
  headIcon,
  onClick,
  disabled,
  selected,
  size,
  variant = 'standalone',
  radiusRules,
  checkMark = false,
  isLoading = false,
  isError = false,
  // ChipsItem payload; omitted from DOM — see chips.types ChipsButtonProps.value
  value: _value,
  ...rest
}: ChipsButtonProps) => {
  void _value;

  const checkmarkSize = size === 'medium' ? 'large' : 'small';
  const typographyType = size === 'medium' ? 'body_large' : 'body_medium';

  return (
    <StyledButton
      type='button'
      {...rest}
      onClick={onClick}
      disabled={disabled || isError}
      $selected={selected}
      $size={size}
      $variant={variant}
      $radiusRules={radiusRules}
      data-error={isError ? 'true' : undefined}
    >
      {isLoading && <Loader variant='bounce' />}
      {checkMark && selected && <Icon.Check size={checkmarkSize} style={{ minWidth: '1rem' }} />}
      {headIcon}
      <Typography color='inherit' type={typographyType}>
        {label}
      </Typography>
    </StyledButton>
  );
};
